import styled from 'styled-components';

export type WrapperStyle = string;

type WrapperStyleProps = {
    wStyle: WrapperStyle;
}

export const StyledWrapper = styled.div(({wStyle}: WrapperStyleProps) => wStyle);
